import { ISlackDestinationFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import styled from 'styled-components';
import { getSlackDestinationOption } from '../../../Slack/utils';
import { theme } from '../../../../styles/theme';
import SlackDestinationLabel from '../../../Slack/SlackDestinationLabel';
import { SvgIcon } from '../../../Icon';

interface IProps {
  destination: ISlackDestinationFieldsFragment;
  disabled?: boolean;
  onDisconnect?: () => void;
}

const Container = styled.button<{ $disabled?: boolean }>`
  display: inline-flex;
  column-gap: 8px;
  align-items: center;
  cursor: pointer;
  outline: none;
  padding: 0;
  font: inherit;
  text-align: left;
  color: ${theme.colors.secondary900};

  &:disabled {
    cursor: none;
    pointer-events: none;
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    color: ${theme.colors.mainBlue};
  }
`;

const Wrapper = styled.div`
  flex: 1;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`;
const Destination = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 2px;
  white-space: nowrap;
`;
const StyledSlackDestinationLabel = styled(SlackDestinationLabel)`
  column-gap: 0;
`;

const DashboardSlackDisconnect = ({
  destination,
  disabled,
  onDisconnect,
}: IProps) => {
  const destinationOption = getSlackDestinationOption(destination);
  return (
    <Container type="button" onClick={onDisconnect} disabled={disabled}>
      <SvgIcon
        name="rte-unlink"
        width={16}
        height={16}
        customFill="currentColor"
      />
      <Wrapper>
        <Destination>
          <div>Remove from</div>
          <StyledSlackDestinationLabel value={destinationOption} />
        </Destination>
        <b>({destination.team.name})</b>
      </Wrapper>
    </Container>
  );
};

export default DashboardSlackDisconnect;
